<template>
  <div
    class="relative bg-no-repeat bg-center bg-cover grow flex flex-col-reverse pb-6 lg:pb-10 h-[10rem] lg:h-[15rem]"
    :style="{
      backgroundImage: `url('./images/covervideo.webp')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }"
  >
    <div class="absolute inset-0 bg-[#2C5BA1] bg-opacity-40"></div>
      <div class="absolute inset-0 flex flex-col items-center justify-center text-white text-3xl font-bold">
        <h1>{{ $t('explorVideo') }}</h1>
        <div class="text-xs lg:text-base font-semibold text-white mt-4">
          <p class="flex flex-row gap-2">
            <a aria-label="Lien Page accueil" class="hover:underline" :href="`/`">{{ $t("home") }}</a>
            <span>/</span>
            <span class="hover:underline">{{ $t("explorVideo") }}</span>
          </p>
        </div>
      </div>
  </div>
    <div class="container p-3.5 sm:px-6 md:px-8 lg:px-16 xl:px-16 mx-auto my-2">
        <div class="container p-3.5 sm:px-6 md:px-8 lg:px-16 xl:px-16 mx-auto my-2">
            
        <div class="grid grid-cols-1 lg:grid-cols-4 gap-4 mt-4" v-if="paginatedVideos.length">
            <div
              v-for="(video, index) in paginatedVideos"
              :key="index"
              class="col-span-1"
            >
              <VideoCard :video="video" />
            </div>
        </div>
        
        <!-- Pagination Controls -->
        <div v-if="totalPages > 1" class="flex justify-center mt-8 mb-4">
          <div class="flex items-center gap-2">
            <button 
              @click="currentPage = 1" 
              :disabled="currentPage === 1"
              class="px-3 py-1 rounded disabled:opacity-50 font-semibold"
              :class="currentPage === 1 ? 'bg-[#F78D1E] cursor-not-allowed' : 'bg-[#F78D1E] hover:bg-orange-200'"
            >
              &laquo;
            </button>
            <button 
              @click="currentPage--" 
              :disabled="currentPage === 1"
              class="px-3 py-1 rounded disabled:opacity-50 font-semibold"
              :class="currentPage === 1 ? 'bg-[#F78D1E] cursor-not-allowed' : 'bg-[#F78D1E] hover:bg-orange-200'"            >
              &lsaquo;
            </button>
            
            <template v-for="page in visiblePages" :key="page">
              <button 
                @click="currentPage = page"
                class="w-8 h-8 rounded font-semibold"
                :class="page === currentPage 
                  ? 'bg-[#2C5BA1] text-white' 
                  : 'bg-[#F78D1E] hover:bg-orange-200 text-black'"
              >
                {{ page }}
              </button>
            </template>
            
            <button 
              @click="currentPage++" 
              :disabled="currentPage === totalPages"
              class="px-3 py-1 rounded disabled:opacity-50 font-semibold"
              :class="currentPage === totalPages ? 'bg-gray-200 cursor-not-allowed' : 'bg-[#F78D1E] hover:bg-orange-200'"
            >
              &rsaquo;
            </button>
            <button 
              @click="currentPage = totalPages" 
              :disabled="currentPage === totalPages"
              class="px-3 py-1 rounded disabled:opacity-50 font-semibold"
              :class="currentPage === totalPages ? 'bg-gray-200 cursor-not-allowed' : 'bg-[#F78D1E] hover:bg-orange-200'"
            >
              &raquo;
            </button>
          </div>
        </div>
        <!-- End Pagination Controls -->
        
        <h1 class="text-xl text-center font-bold mb-4">
          {{ $t("latest_articles") }}
        </h1>
        <div
          class="container p-3.5 sm:px-4 md:px-8 lg:px-16 xl:px-16 mx-auto my-2"
        >
          <ArticleList :articles="articles" />
        </div>
        <div
    class="container p-3.5 lg:px-12 min-1700:pl-6 min-1700:pr-12 mx-auto my-2 relative"
    v-if="this.imageListBanner1.length !== 0"
    data-aos="fade-up"
  >
    <BannerPub :images="this.imageListBanner1" />
  </div>
        </div>
    </div>
</template>
<script>
import videos from "@/assets/video.json";
import BannerPub from "../partial/BannerPub.vue";
import VideoCard from "../partial/VideoCard.vue";
import ArticleList from "../partial/ArticleList.vue";
import { mapActions } from "vuex";
import { updateMetaTagsPage } from "../utils/filters";

export default {
    components:{
         BannerPub,
         VideoCard,
         ArticleList
    },
    data(){
        return {
            currentLanguage: this.$i18n.locale,                    
            imageListBanner1: [],
            imageListBanner2: [],
            imageListBanner3: [],
            articles: [],
            videos,
            currentPage: 1,
            itemsPerPage: 8
        }
    },
    computed: {
        paginatedVideos() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.videos.slice(start, end);
        },
        totalPages() {
            return Math.ceil(this.videos.length / this.itemsPerPage);
        },
        visiblePages() {
            const maxVisible = 5; // Number of visible page buttons
            const start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
            const end = Math.min(this.totalPages, start + maxVisible - 1);
            
            const pages = [];
            for (let i = start; i <= end; i++) {
                pages.push(i);
            }
            return pages;
        }
    },
    watch: {
        "$i18n.locale"(newLocale) {
            this.currentLanguage = newLocale;
            this.addCanonicalLink();
            this.updateMetaTags(this.currentLanguage);
        },
    },
    methods:{
      ...mapActions(["fetchBanners", "fetchArticles"]),
    addCanonicalLink() {
        const currentUrl = window.location.href; // Get the current URL
        const currentLanguage = this.currentLanguage; // Fetch the current language
        let canonicalLink = document.querySelector("link[rel='canonical']");
  
        // Modify the URL based on the language
        const url = new URL(currentUrl);
        const pathSegments = url.pathname.split("/").filter(Boolean); // Remove empty segments
  
        if (currentLanguage === "ar" || currentLanguage === "en" || currentLanguage === "kor" || currentLanguage === "ru" || currentLanguage === 'zh' || currentLanguage === 'ja') {
          // Add language prefix if not already present
          if (pathSegments[0] !== currentLanguage) {
            pathSegments.unshift(currentLanguage);
          }
        } else if (
          (currentLanguage === "fr" && pathSegments[0] === "ar") ||
          pathSegments[0] === "en"||
          pathSegments[0] === "ru" || pathSegments[0] === 'ja' || pathSegments[0] === 'zh'  || currentLanguage === "kor"
        ) {
          // Remove language prefix if "fr" (default)
          pathSegments.shift();
        }
  
        url.pathname = "/" + pathSegments.join("/"); // Construct the new path
        const canonicalUrl = url.toString(); // Get the full URL as a string
  
        if (canonicalLink) {
          // Update the existing canonical link
          canonicalLink.setAttribute("href", canonicalUrl);
        } else {
          // Create a new canonical link
          canonicalLink = document.createElement("link");
          canonicalLink.setAttribute("rel", "canonical");
          canonicalLink.setAttribute("href", canonicalUrl);
          document.head.appendChild(canonicalLink);
        }
    },
        updateMetaTags(language) {
const metaData = {
  // Russian (ru)
  "meta_title_ru": "Исследуйте Тунис на видео | Плейлист TunisiaGoTravel ",
"meta_description_ru": "Откройте для себя Тунис через видео с нашим плейлистом TunisiaGoTravel: направления, мероприятия, отели, пляжи, культура и многое другое. ",
  "meta_keywords_ru": "видео Тунис, TunisiaGoTravel, туризм Тунис, тунисские направления, пляжи, отели, тунисская культура, влог Тунис, YouTube Тунис ",

  // French (fr)
 "meta_title_fr": "Explorez la Tunisie en Vidéo | Playlist TunisiaGoTravel ",
  "meta_description_fr": "Découvrez la Tunisie en vidéo avec notre playlist TunisiaGoTravel : destinations, activités, hôtels, plages, culture et plus encore. ",
  "meta_keywords_fr": "vidéos Tunisie, TunisiaGoTravel, tourisme Tunisie, destinations tunisiennes, plages, hôtels, culture tunisienne, vlog Tunisie, YouTube Tunisie",

  // English (en)
 "meta_title_en": "Explore Tunisia in Video | TunisiaGoTravel Playlist ",
   "meta_description_en": "Discover Tunisia through video with our TunisiaGoTravel playlist: destinations, activities, hotels, beaches, culture and more. ",
    "meta_keywords_en": "Tunisia videos, TunisiaGoTravel, Tunisia tourism, Tunisian destinations, beaches, hotels, Tunisian culture, Tunisia vlog, YouTube Tunisia ",

  // Arabic (ar)
   "meta_title_ar": "استكشف تونس بالفيديو | قائمة تشغيل TunisiaGoTravel ",
 "meta_description_ar": "اكتشف تونس عبر الفيديو مع قائمة التشغيل TunisiaGoTravel: وجهات، أنشطة، فنادق، شواطئ، ثقافة والمزيد. ",
 "meta_keywords_ar": " فيديوهات تونس, TunisiaGoTravel, سياحة تونس, وجهات تونسية, شواطئ, فنادق, ثقافة تونسية, فلوج تونس, يوتيوب تونس",

  // Chinese (chi)
  "meta_title_zh": "视频探索突尼斯 | TunisiaGoTravel播放列表 ",
  "meta_description_zh": "通过我们的TunisiaGoTravel播放列表视频发现突尼斯：目的地、活动、酒店、海滩、文化等更多内容。",
  "meta_keywords_zh": "突尼斯视频, TunisiaGoTravel, 突尼斯旅游, 突尼斯目的地, 海滩, 酒店, 突尼斯文化, 突尼斯视频博客, 突尼斯YouTube ",

  // Korean (kor)
  "meta_title_ko": "비디오로 알아보는 튀니지 | TunisiaGoTravel 재생목록 ",
  "meta_description_ko": "TunisiaGoTravel 재생목록으로 비디오 속 튀니지를 발견하세요: 여행지, 활동, 호텔, 해변, 문화 등을 확인할 수 있습니다. ",
  "meta_keywords_ko": "튀니지 비디오, TunisiaGoTravel, 튀니지 관광, 튀니지 여행지, 해변, 호텔, 튀니지 문화, 튀니지 블로그, 유튜브 튀니지 ",

  // Japanese (jpn)
  "meta_title_ja": "動画で探るチュニジア | TunisiaGoTravelプレイリスト ",
  "meta_description_ja": "TunisiaGoTravelプレイリストでチュニジアを動画で発見: 目的地、アクティビティ、ホテル、ビーチ、文化など。",
  "meta_keywords_ja": "チュニジア動画, TunisiaGoTravel, チュニジア観光, チュニジアの目的地, ビーチ, ホテル, チュニジア文化, チュニジアブログ, YouTubeチュニジア "
};
updateMetaTagsPage(language,metaData,'Videos')
    },
          async loadBannerData() {
        try {
          const data = await this.fetchBanners();
          let arrayBanners = Object.values(data);
          this.imageListBanner1 = arrayBanners[0];
          this.imageListBanner2 = arrayBanners[1];
          this.imageListBanner3 = arrayBanners[2];
        } catch (error) {
          console.error("Error loading banners: ", error);
        }
      },
      async loadArticles() {
        try {
          const articlesList = await this.fetchArticles();
          this.articles = articlesList;
        } catch (error) {
          console.error("Error loading articlesList: ", error);
        }
      },
    },
    async created() {
      this.$store.dispatch("setLoading", true);
      try {
        await Promise.all([this.loadBannerData(), this.loadArticles()]);
        this.updateMetaTags(this.currentLanguage);
      } catch (error) {
        console.log("error ", error);
      } finally {
        this.$store.dispatch("setLoading", false);
      }
    },
}
</script>